import React from "react";
import { contactInfo, heroContent } from "../../../data/portfolioData";
import { HandArrow, ScribbleLine } from "../../../components/Sketch";
import profilePhoto from "../../../Assets/profile.jpg";

export const HeroIntro = ({ scrollToProjects }) => {
  return (
    <div className="hero-grid">
      <div className="hero-inner hero-enter">
        <p className="hero-name">
          {heroContent.name}
          <span className="hero-role">{heroContent.role}</span>
        </p>

        <h1 className="hero-title">
          More <mark className="marker">sales</mark>,{" "}
          <span className="scribble">
            less manual work
            <ScribbleLine />
          </span>
          .
        </h1>

        <p className="hero-tagline">{heroContent.lead}</p>

        <div className="hero-ctas">
          <button type="button" className="btn btn-accent" onClick={scrollToProjects}>
            See results
            <svg width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true">
              <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
          <a href={`mailto:${contactInfo.email}`} className="btn">
            Email me
          </a>
        </div>
      </div>

      {/* Swap src/Assets/profile.jpg for the LinkedIn photo (4:5, about 800x1000) to update this. */}
      <figure className="hero-photo hero-enter hero-enter-late">
        <span className="hero-photo-tape" aria-hidden="true" />
        <img
          src={profilePhoto}
          alt="Lê Mạnh Hùng, smiling, in glasses and a dark jacket"
          width="800"
          height="1000"
        />
        <figcaption className="hand-note hero-photo-note" aria-hidden="true">
          <HandArrow />
          <span>that's me!</span>
        </figcaption>
      </figure>
    </div>
  );
};
